import React from 'react'
import { connect } from 'react-redux'
import {TextInput} from '../input/index'
import SearchSuggestions from './SearchSuggestions'
import {getQueryResults, selectResults, clearSearch} from '../../../redux/modules/search'
import {getSearchSuggestionResults, selectSuggestions, moveCursor} from '../../../redux/modules/searchSuggestions'
import {toggleSearchIsFocused} from '../../../redux/modules/ui'
import {withRouter} from 'react-router'
import {toJS} from '../../../util/ToJS'
import qs from 'query-string'
import './searchbox.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function stopBodyScrolling (bool) {
  if (bool === true) {
    document.body.addEventListener('touchmove', freezeVp, false)
  } else {
    document.body.removeEventListener('touchmove', freezeVp, false)
  }
}
const freezeVp = function(e) {
  e.preventDefault()
}

class SearchBoxComponent extends React.PureComponent {
  textInput = null;
  constructor(props) {
    super(props)

    this.state = {
      currQuery: props.query,
      savedQuery: props.query,
    }

    this.keyDown = this.keyDown.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.handleBodyClass = this.handleBodyClass.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
  }
  componentDidMount() {
    this.handleBodyClass()
  }
  componentDidUpdate(nextProps) {
    this.handleBodyClass()
    // this.textInput.selectionStart = this.textInput.value.length;
    // this.textInput.selectionEnd = this.textInput.value.length;
  }
  componentWillReceiveProps(nextProps) {
    const {cursor, query, suggestions, isEntryPoint} = nextProps
    if (isEntryPoint && cursor > -1) {
      this.setState({
        currQuery: suggestions[cursor].title
      })
    } else {
      this.setState({
        currQuery: query
      })
    }
  }
  componentWillUnmount() {
    const {setFocus} = this.props
    setFocus(false)
    document.body.className = document.body.className.replace('searchbox--open','')
    stopBodyScrolling(false)
  }
  keyDown(e) {
    const {isEntryPoint,moveCursor, getQueryResults, cursor, suggestions, history, setFocus} = this.props
    const {currQuery} = this.state
    if (e.key === 'Enter'){
      e.preventDefault()
      let query = qs.parse(window.location.search, {arrayFormat: 'bracket'})
      query.q = currQuery
      if (isEntryPoint) {
        if (cursor > -1 && suggestions[cursor].slug) {
          history.push({
            pathname: suggestions[cursor].slug,
          })
          setFocus(false)
          this.clearSearch()
          this.textInput.blur()
        } else {
          history.push({
            pathname: '/search',
            search: qs.stringify(query, {arrayFormat: 'bracket'})
          })
          this.textInput.blur()
        }

      } else {
        getQueryResults(currQuery)
        history.replace({
          pathname: '/search',
          search: qs.stringify(query, {arrayFormat: 'bracket'})
        })
        this.textInput.blur()
      }
    } else if (e.key === 'ArrowDown') {
      if (isEntryPoint) {
        e.preventDefault()
        moveCursor(1)
      }
    } else if (e.key === 'ArrowUp') {
      if (isEntryPoint) {
        e.preventDefault()
        moveCursor(-1)
      }
    } else if (e.key === 'Escape') {
      if (isEntryPoint) {
        e.preventDefault()
        setFocus(false)
        this.textInput.blur()
      }
    }
  }
  onSearch(e) {
    const {getQueryResults, getSearchSuggestionResults, isEntryPoint} = this.props
    const query = e.target.value
    if (isEntryPoint) {
      getSearchSuggestionResults(query)
    } else {
      getQueryResults(query)
    }
  }
  handleBodyClass() {
    const {isFocused} = this.props
    if (isFocused) {
      if (!document.body.classList.contains('searchbox--open')) {
        //let offset = document.body.scrollTop
        //document.body.style.top = (offset * -1) + 'px';
        stopBodyScrolling(true)
        document.body.className  += ' searchbox--open'

      }
    } else {
      //let offset = parseInt(document.body.style.top, 10)
      stopBodyScrolling(false)
      document.body.className = document.body.className.replace('searchbox--open','')
      // document.body.scrollTop = (offset * -1);

    }
  }
  clearSearch() {
    const {clearSearch} = this.props
    this.setState({
      currQuery: ''
    })
    clearSearch()
  }

  render() {
    const {isEntryPoint, query, autofocus, className, id, disabled, placeholder, setFocus, isFocused} = this.props
    const {currQuery} = this.state
    const additionalProps = {}
    const classNames = ['searchbox']
    if (query) {
      classNames.push('searchbox--with-text')
    }
    if (autofocus) {
      const moveCursorToEnd = (e) => {
        const temp_value = e.target.value
        e.target.value = ''
        e.target.value = temp_value
      }
      additionalProps['autoFocus'] = autofocus
      additionalProps['onFocus'] = moveCursorToEnd
    }
    if (id) {
      additionalProps['id'] = id
    }
    if (disabled) {
      additionalProps['disabled'] = disabled
    }
    return (
      <div
        style={{position:'relative'}}
        className={className}>
        <SearchSuggestions
          isEnabled={isFocused && isEntryPoint}
          currQuery={currQuery} />
        <div
          onClick={()=>setFocus(false)}
          className={isFocused && isEntryPoint ? 'searchbox__overlay searchbox__overlay--active' : 'searchbox__overlay'} />
        <div
          onClick={()=>{
            this.textInput.focus()
            if (isEntryPoint) {
              setFocus(true)
            }
          }}
          className={isFocused && isEntryPoint ? 'searchbox__container searchbox__container--focus' : 'searchbox__container'}>
          <form action="." autoComplete="off">
            <TextInput
              setRef={node => this.textInput = node}
              className={classNames.join(' ')}
              value={currQuery}
              onFocus={(e)=>{
                e.preventDefault()
                e.stopPropagation()
                if (isEntryPoint) {
                  setFocus(true)
                }
              }}
              name='search'
              type='search'
              onKeyDown={this.keyDown}
              onChange={this.onSearch}
              {...additionalProps}
            />
          </form>
          {
            currQuery
              ? <button
                onFocus={()=>{
                  if (isEntryPoint) {
                    setFocus(true)
                  }
                }}
                onBlur={()=>{
                  if (isEntryPoint) {
                    setFocus(false)
                  }
                }}
                onClick={this.clearSearch}
                type="button"
                className='searchbox__icon'>
                <FontAwesomeIcon icon={['fa', 'times-circle']} />
              </button>
              : <span
                className='searchbox__icon'>
                <FontAwesomeIcon icon={['fa', 'search']} />
              </span>
          }
          {
            !isFocused && !currQuery
              ? [
                <div key='placeholder' className='searchbox__placeholder'>
                  {placeholder ? placeholder : 'Search for math and science topics'}
                </div>,
                <div key='placeholder--mobile' className='searchbox__placeholder searchbox__placeholder--mobile'>
                  {placeholder ? placeholder : 'Search for topics'}
                </div>,
              ]
              : null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, {isEntryPoint}) => (
  isEntryPoint
    ? {
      isFocused: state.getIn(['ui','searchIsFocused']),
      ...selectSuggestions(state)
    }
    : {
      isFocused: state.getIn(['ui','searchIsFocused']),
      ...selectResults(state),
    }
)
const mapDispatchToProps = dispatch => ({
  getQueryResults: (query) => dispatch(getQueryResults(query)),
  getSearchSuggestionResults: (query) => dispatch(getSearchSuggestionResults(query)),
  setFocus: (isFocused) => dispatch(toggleSearchIsFocused(isFocused)),
  moveCursor: (offset) => dispatch(moveCursor(offset)),
  clearSearch: () => dispatch(clearSearch())
})

export const SearchBox = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(SearchBoxComponent)))



// WEBPACK FOOTER //
// ./src/core/components/search-box/SearchBox.js